<section-info [overrideTitle]="'validation.overrideTitle' | translate" [overrideDescription]="''">
</section-info>
<div *ngFor="let group of groupedValidationMessages; let i = index" class="mb-3"
    [ngClass]="{ 'border-bottom': (groupedValidationMessages.length - 1) != i, 'border-bottom-0': (groupedValidationMessages.length - 1) == i }"
    style="padding-bottom: 1rem;">
    <header>
        <a class="validation-message-label" [routerLink]="'../' + getFormLinkFromGroupedValidationMessage(group[1])" tabindex="-1">
            {{ group[0] }}
        </a>
        <label class="validation-control-name-label"></label>
        <label class="validation-form-name-label"></label>
    </header>
    <main>
        <div class="validation-view-item" *ngFor="let validationMessage of group[1]">
            <span class="validation-message" [outerHTML]="validationMessage.message"></span>
            <span class="validation-control-name">{{validationMessage.controlName}}</span>
            <a class="validation-form-link"></a>
        </div>
    </main>
</div>